import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { warehouseCirculationReportManagementRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE];

const warehouseCirculationReportManagementRouteMetadata: IRouteMetadataObj<
  typeof warehouseCirculationReportManagementRoutesObj
> = {
  list: {
    title: "reportManagement.index.title",
    description: "empty",
    lazy: () =>
      import("@pages/reportManagement/warehouseCirculationReport/table/page"),
    mode: "index",
    type: "main",
    icon: "FileChartLine",
    breadcrumbs: [],
    permission,
  },
};

export const warehouseCirculationReportManagementRoutes = createRoute<
  typeof warehouseCirculationReportManagementRoutesObj
>(
  warehouseCirculationReportManagementRoutesObj,
  warehouseCirculationReportManagementRouteMetadata,
);
